<div class="container">
  <div class="notification-section">
    <div class="title-section">
      <div class="title">Notifications</div>
      <div class="link-section">
        <a class="link" [class.disabled]="!isNotificationAvailable" (click)="updateAllNotifications('READ_ALL')">Mark all as read</a>
        <a class="link" [class.disabled]="!isNotificationAvailable" (click)="updateAllNotifications('DISMISS_ALL')">Clear all</a>
      </div>

    </div>
    <div class="list-section"  (scroll)="onScroll($event)">
      @if (notifications$ | async; as notifications;) {
        @for (notification of notifications$ | async; track notification) {
          <div class="notification-list" [class.highlight]="notification.is_read">
            <div class="content-section">
              <span class="notification-title">{{notification.title}}</span>
              <span class="message">{{notification.message}}</span>
              <span class="date" style="color:#919191;">{{timeFromNow(notification.created_at)}}</span>
            </div>
            <div class="close-btn">
              <mat-icon (click)="updateNotification('DISMISS', notification)">close</mat-icon>
            </div>
          </div>
        }
        @if (!notifications.length) {
          <div class="no-records-section">No records found.</div>
        }
      }
      @if (loading && initialLoad) {
        <div class="loader-section">
          <mat-spinner diameter="20"></mat-spinner>  <span>Loading...</span>
        </div>
      }
    </div>
  </div>
  @if (loading && !initialLoad) {
    <div class="loader">
      <mat-spinner diameter="30"></mat-spinner>
    </div>
  }
</div>